import { TextPuppeteerDriver } from '../Text/Text.puppeteer.driver';

export interface HeadingPuppeteerDriver extends TextPuppeteerDriver {}
